import { get } from '../../../utils/api';

export default {
  getCatalogGood: id => get({ url: 'catalog/good', data: { id } }),
};
